import React, { useEffect, useState } from "react";
import SidebarNav from "../sidebar";
import { Link, useParams } from "react-router-dom";
import { getUserById, getUserWalletTrxById } from "../../../service/api";
import InputMask from "react-input-mask";
import { message } from "antd";
import { IoCopyOutline } from "react-icons/io5";
import moment from "moment";
import JsonPopupModal from "../JSON modal";

const WalletTr = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const [user, setUser] = useState();
  const [signzeyData, setSignzeyData] = useState([]);
  const [open, setOpen] = useState(false);
  const [jsonData, setJsonData] = useState();
  const [title, setTitle] = useState("");

  const getOrderData = (id) => {
    getUserWalletTrxById(id)?.then((res) => {
      if (res?.status) {
        console.log("res?.data?.result[0]", res?.data);
        setData(res?.data[0]);

        // Check if userDetails exists in the response (no need to fetch separately)
        if (res?.data[0]?.userDetails) {
          setUser(res?.data[0]?.userDetails);
        } else if (res?.data[0]?.userId) {
          getUser(res?.data[0]?.userId);
        }

        // Handle signzey data if it exists
        if (res?.data[0]?.signzeyData?.ruleEvaluationMetrics) {
          let signzey = Object.entries(
            res?.data[0]?.signzeyData?.ruleEvaluationMetrics
          ).map(([ruleId, { status, timetaken }]) => ({
            ruleId,
            status,
            timetaken,
          }));
          const grouped =
            signzey && signzey?.length > 0
              ? signzey.reduce((acc, item) => {
                  const key = item.status;
                  if (!acc[key]) {
                    acc[key] = [];
                  }
                  acc[key].push(item);
                  return acc;
                }, {})
              : [];
          setSignzeyData(grouped);
        }
      }
    });
  };

  const getUser = (id) => {
    getUserById(id)?.then((res) => {
      setUser(res?.data);
    });
  };

  useEffect(() => {
    if (id) {
      getOrderData(id);
    }
  }, [id]);

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    message.success("Copied to clipboard!");
  };

  // Helper to shorten long addresses
  const shorten = (str) => {
    return str?.length > 10 ? `${str.slice(0, 6)}...${str.slice(-4)}` : str;
  };
  return (
    <>
      <SidebarNav />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">Wallet Transaction</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Wallet Transaction</li>
                </ul>
              </div>
              <div className="col-auto">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setTitle("Complete Transaction Data");
                    setJsonData(data);
                    setOpen(true);
                  }}
                >
                  View Complete JSON
                </button>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-md-12">
              <div className="profile-header">
                <div className="row align-items-center">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <h5 className="col">User Details</h5>
                  </div>
                  <div className={`page-grid grid-4 `}>
                    <div>
                      <label>FirstName</label>
                      <InputMask
                        className="form-control"
                        value={user?.firstName}
                        readOnly
                      ></InputMask>
                    </div>
                    <div>
                      <label>LastName</label>
                      <InputMask
                        className="form-control"
                        value={user?.lastName}
                        readOnly
                      ></InputMask>
                    </div>
                    <div>
                      <label>Email</label>
                      <InputMask
                        className="form-control"
                        value={user?.email}
                        readOnly
                      ></InputMask>
                    </div>
                    <div>
                      <label>Phone Number</label>
                      <InputMask
                        className="form-control"
                        value={user?.phoneNumber}
                        readOnly
                      ></InputMask>
                    </div>
                    <div>
                      <label>User ID</label>
                      <InputMask
                        className="form-control"
                        value={user?.userId}
                        readOnly
                      ></InputMask>
                    </div>
                    <div>
                      <label>Account Status</label>
                      <InputMask
                        className="form-control"
                        value={user?.accountStatus}
                        readOnly
                      ></InputMask>
                    </div>
                    <div>
                      <label>KYC Status</label>
                      <InputMask
                        className="form-control"
                        value={user?.kycStatus}
                        readOnly
                      ></InputMask>
                    </div>
                    <div>
                      <label>Nationality</label>
                      <InputMask
                        className="form-control"
                        value={user?.nationality}
                        readOnly
                      ></InputMask>
                    </div>
                    <div>
                      <label>Country</label>
                      <InputMask
                        className="form-control"
                        value={user?.country}
                        readOnly
                      ></InputMask>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-12">
              <div className="profile-header">
                <div className="row align-items-center">
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <h5 className="col">Order Details</h5>
                  </div>
                  <div className={`page-grid grid-4`}>
                    <div>
                      <label>Transaction ID</label>
                      <InputMask
                        className="form-control"
                        value={data?.transactionId}
                        readOnly
                      />
                    </div>

                    <div>
                      <label>Order Amount</label>
                      <InputMask
                        className="form-control"
                        value={`${data?.amount} ${data?.coinDetails?.symbol || data?.tokenName || ''}`}
                        readOnly
                      />
                    </div>

                    <div>
                      <label>Coin Name</label>
                      <InputMask
                        className="form-control"
                        value={data?.coinDetails?.name}
                        readOnly
                      />
                    </div>

                    <div>
                      <label>Transaction Type</label>
                      <InputMask
                        className="form-control"
                        value={data?.type}
                        readOnly
                      />
                    </div>

                    <div>
                      <label>Sub Type</label>
                      <InputMask
                        className="form-control"
                        value={data?.subType}
                        readOnly
                      />
                    </div>

                    <div>
                      <label>Transaction Status</label>
                      <InputMask
                        className="form-control"
                        value={data?.trxStatus}
                        readOnly
                      />
                    </div>

                    <div>
                      <label>Status</label>
                      <InputMask
                        className="form-control"
                        value={data?.status === 0 ? 'Active' : 'Inactive'}
                        readOnly
                      />
                    </div>

                    <div>
                      <label>Order Id</label>
                      <InputMask
                        className="form-control"
                        value={data?._id}
                        readOnly
                      />
                    </div>

                    <div>
                      <label>Created At</label>
                      <InputMask
                        className="form-control"
                        value={moment(data?.createdAt)?.format(
                          "DD/MM/YYYY h:mm A"
                        )}
                        readOnly
                      />
                    </div>

                    <div>
                      <label>Updated At</label>
                      <InputMask
                        className="form-control"
                        value={moment(data?.updatedAt)?.format(
                          "DD/MM/YYYY h:mm A"
                        )}
                        readOnly
                      />
                    </div>

                    {data?.fromAddress && (
                      <div>
                        <label>From Address</label>
                        <div className="d-flex align-items-center gap-2">
                          <input
                            className="form-control"
                            value={shorten(data?.fromAddress)}
                            readOnly
                          />
                          <IoCopyOutline
                            style={{ cursor: "pointer" }}
                            onClick={() => copyToClipboard(data?.fromAddress)}
                          />
                        </div>
                      </div>
                    )}

                    {data?.toAddress && (
                      <div>
                        <label>To Address</label>
                        <div className="d-flex align-items-center gap-2">
                          <input
                            className="form-control"
                            value={shorten(data?.toAddress)}
                            readOnly
                          />
                          <IoCopyOutline
                            style={{ cursor: "pointer" }}
                            onClick={() => copyToClipboard(data?.toAddress)}
                          />
                        </div>
                      </div>
                    )}

                    {data?.txHash && (
                      <div>
                        <label>Tx Hash</label>
                        <div className="d-flex align-items-center gap-2">
                          <input
                            className="form-control"
                            value={shorten(data?.txHash)}
                            readOnly
                          />
                          <IoCopyOutline
                            style={{ cursor: "pointer" }}
                            onClick={() => copyToClipboard(data?.txHash)}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {data?.coinDetails && (
            <div className="row mt-2">
              <div className="col-md-12">
                <div className="profile-header">
                  <div className="row align-items-center">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <h5 className="col">Coin Details</h5>
                    </div>
                    <div className={`page-grid grid-4 `}>
                      {data?.coinDetails?.image && (
                        <div>
                          <label>Coin Image</label>
                          <div>
                            <img
                              src={data?.coinDetails?.image}
                              alt={data?.coinDetails?.name}
                              style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                            />
                          </div>
                        </div>
                      )}
                      <div>
                        <label>Symbol</label>
                        <InputMask
                          className="form-control"
                          value={data?.coinDetails?.symbol}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Name</label>
                        <InputMask
                          className="form-control"
                          value={data?.coinDetails?.name}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Price (INR)</label>
                        <InputMask
                          className="form-control"
                          value={data?.coinDetails?.price}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Chain Address</label>
                        <InputMask
                          className="form-control"
                          value={data?.coinDetails?.chain_address}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Status</label>
                        <InputMask
                          className="form-control"
                          value={data?.coinDetails?.status === 0 ? 'Active' : 'Inactive'}
                          readOnly
                        ></InputMask>
                      </div>
                    </div>
                    <p
                      onClick={() => {
                        setTitle("Coin Details");
                        setJsonData(data?.coinDetails);
                        setOpen(true);
                      }}
                      style={{
                        width: "fit-content",
                        marginLeft: "auto",
                        color: "blue",
                        cursor: "pointer",
                        textAlign: "right",
                      }}
                    >
                      View more
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {data?.userFundingWalletDetails && (
            <div className="row mt-2">
              <div className="col-md-12">
                <div className="profile-header">
                  <div className="row align-items-center">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <h5 className="col">User Funding Wallet Details</h5>
                    </div>
                    <div className={`page-grid grid-4 `}>
                      <div>
                        <label>Wallet Amount</label>
                        <InputMask
                          className="form-control"
                          value={`${data?.userFundingWalletDetails?.amount} ${data?.coinDetails?.symbol || ''}`}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Is Active</label>
                        <InputMask
                          className="form-control"
                          value={data?.userFundingWalletDetails?.isActive ? 'Yes' : 'No'}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Is Locked</label>
                        <InputMask
                          className="form-control"
                          value={data?.userFundingWalletDetails?.isLocked ? 'Yes' : 'No'}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Is Frozen</label>
                        <InputMask
                          className="form-control"
                          value={data?.userFundingWalletDetails?.isFrozen ? 'Yes' : 'No'}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Status</label>
                        <InputMask
                          className="form-control"
                          value={data?.userFundingWalletDetails?.status === 0 ? 'Active' : 'Inactive'}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Created At</label>
                        <InputMask
                          className="form-control"
                          value={moment(data?.userFundingWalletDetails?.createdAt)?.format("DD/MM/YYYY h:mm A")}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Updated At</label>
                        <InputMask
                          className="form-control"
                          value={moment(data?.userFundingWalletDetails?.updatedAt)?.format("DD/MM/YYYY h:mm A")}
                          readOnly
                        ></InputMask>
                      </div>
                    </div>
                    <p
                      onClick={() => {
                        setTitle("User Funding Wallet Details");
                        setJsonData(data?.userFundingWalletDetails);
                        setOpen(true);
                      }}
                      style={{
                        width: "fit-content",
                        marginLeft: "auto",
                        color: "blue",
                        cursor: "pointer",
                        textAlign: "right",
                      }}
                    >
                      View more
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {data?.notabeneData && (
            <div className="row mt-2">
              <div className="col-md-12">
                <div className="profile-header">
                  <div className="row align-items-center">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <h5 className="col">Notabene Details</h5>
                    </div>
                    <div className={`page-grid grid-4 `}>
                      <div>
                        <label>Currency</label>
                        <InputMask
                          className="form-control"
                          value={
                            data?.notabeneData?.amountInLocalCurrency?.currency
                          }
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Amount in local currency</label>
                        <InputMask
                          className="form-control"
                          value={
                            data?.notabeneData?.amountInLocalCurrency
                              ?.amountInLocalCurrency
                          }
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Originator DID</label>
                        <InputMask
                          className="form-control"
                          value={data?.notabeneData?.originatorDid}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Originator VASP DID</label>
                        <InputMask
                          className="form-control"
                          value={data?.notabeneData?.originatorVASPdid}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Notabene Id</label>
                        <InputMask
                          className="form-control"
                          value={data?.notabeneData?.id}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Protocol</label>
                        <InputMask
                          className="form-control"
                          value={data?.notabeneData?.protocol}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Status</label>
                        <InputMask
                          className="form-control"
                          value={data?.notabeneData?.status}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Transaction Type</label>
                        <InputMask
                          className="form-control"
                          value={data?.notabeneData?.transactionType}
                          readOnly
                        ></InputMask>
                      </div>
                    </div>
                    <p
                      onClick={() => {
                        setTitle("Notabene details");
                        setJsonData(data?.notabeneData);
                        setOpen(true);
                      }}
                      style={{
                        width: "fit-content",
                        marginLeft: "auto",
                        color: "blue",
                        cursor: "pointer",
                        textAlign: "right",
                      }}
                    >
                      View more
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
          {data?.trmTransferData && (
            <div className="row mt-2">
              <div className="col-md-12">
                <div className="profile-header">
                  <div className="row align-items-center">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <h5 className="col">TRM Details</h5>
                    </div>
                    <div className={`page-grid grid-4 `}>
                      <div>
                        <label>Account UUID</label>
                        <InputMask
                          className="form-control"
                          value={data?.trmTransferData?.accountUuid}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>UUID</label>
                        <InputMask
                          className="form-control"
                          value={data?.trmTransferData?.uuid}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Chain</label>
                        <InputMask
                          className="form-control"
                          value={data?.trmTransferData?.chain}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Amount</label>
                        <InputMask
                          className="form-control"
                          value={`${data?.trmTransferData?.assetAmount} ${data?.trmTransferData?.asset}`}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Fiat Currency</label>
                        <InputMask
                          className="form-control"
                          value={`${data?.trmTransferData?.fiatCurrency}`}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Fiat Value</label>
                        <InputMask
                          className="form-control"
                          value={`${data?.trmTransferData?.fiatValue}`}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Screen Status</label>
                        <InputMask
                          className="form-control"
                          value={`${data?.trmTransferData?.screenStatus}`}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Transfer Type</label>
                        <InputMask
                          className="form-control"
                          value={`${data?.trmTransferData?.transferType}`}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Time</label>
                        <InputMask
                          className="form-control"
                          value={`${moment(
                            data?.trmTransferData?.submittedAt
                          )?.format("DD/MM/YYYY h:mm A")}`}
                          readOnly
                        ></InputMask>
                      </div>
                    </div>
                    <p
                      onClick={() => {
                        setTitle("TRM details");

                        setJsonData(data?.trmTransferData);
                        setOpen(true);
                      }}
                      style={{
                        width: "fit-content",
                        marginLeft: "auto",
                        color: "blue",
                        cursor: "pointer",
                        textAlign: "right",
                      }}
                    >
                      View more
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
          {data?.signzeyData && (
            <div className="row mt-2">
              <div className="col-md-12">
                <div className="profile-header">
                  <div className="row align-items-center">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <h5 className="col">Signzey Details</h5>
                    </div>
                    <div className={`page-grid grid-4 `}>
                      <div>
                        <label>Acknowledgement ID</label>
                        <InputMask
                          className="form-control"
                          value={data?.signzeyData?.acknowledgementId}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Flagged</label>
                        <InputMask
                          className="form-control"
                          value={data?.signzeyData?.flagged}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Team ID</label>
                        <InputMask
                          className="form-control"
                          value={data?.signzeyData?.teamId}
                          readOnly
                        ></InputMask>
                      </div>
                      <div>
                        <label>Transaction ID</label>
                        <InputMask
                          className="form-control"
                          value={data?.signzeyData?.txnId}
                          readOnly
                        ></InputMask>
                      </div>

                      {signzeyData &&
                        Object.entries(signzeyData)?.length > 0 &&
                        Object.entries(signzeyData)?.map((obj, i) => {
                          return (
                            <div>
                              <label>Rules data</label>
                              <InputMask
                                className="form-control"
                                value={`${obj[0]}: ${obj[1]?.length}`}
                                readOnly
                              ></InputMask>
                            </div>
                          );
                        })}
                    </div>
                    <p
                      onClick={() => {
                        setTitle("Signzey details");
                        setJsonData(data?.signzeyData);
                        setOpen(true);
                      }}
                      style={{
                        width: "fit-content",
                        marginLeft: "auto",
                        color: "blue",
                        cursor: "pointer",
                        textAlign: "right",
                      }}
                    >
                      View more
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <JsonPopupModal
          open={open}
          handleClose={() => {
            setOpen(false);
            setJsonData();
            setTitle("");
          }}
          jsonData={jsonData}
          title={title}
        />
      </div>
    </>
  );
};

export default WalletTr;
